import {
  CANCEL_SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_START,
  CANCEL_SUBSCRIPTION_SUCCESS,
  IS_SUBSCRIBED_TO_FAILURE,
  IS_SUBSCRIBED_TO_START,
  IS_SUBSCRIBED_TO_SUCCESS,
  FETCH_PERFORMER_SUBSCRIPTION_PLAN_START,
  FETCH_PERFORMER_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_SUBSCRIPTION_PLAN_START,
  FETCH_SUBSCRIPTOIN_PLAN_SUCCESS,
  SET_SUBSCRIPTION_FREE_FAILED,
  SET_SUBSCRIPTION_FREE_START,
  SET_SUBSCRIPTION_FREE_SUCCESS,
  TOGGLE_SUBSCRIPTION_FREE,
  UPDATE_DEFAULT_SUBSCRIPTION,
  SUBSCRIBE_TO_PLAN_START,
  SUBSCRIBE_TO_PLAN_SUCCESS,
  SUBSCRIBE_TO_PLAN_FAILURE,
} from "../actions/ActionConstant";

const initialState = {
  subscriptionPlans: {
    data: {
      default: {},
      bundles: [],
    },
    error: false,
    loading: false,
    inputData: {},
    defaultAmount: null,
  },
  isSubscribedTo: {
    data: {},
    error: false,
    loading: false,
  },
  freeSubscription: {
    loading: true,
    is_free: null,
  },
  onBoardSubscription: {
    is_first_open : false,
  },
  cancelSubscription: {
    success: false,
    loading: false,
    error: false
  },
  subscribeToPlan: {
    success: false,
    loading: false,
    error: false
  },
};

const SubscriptionPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLAN_START:
    case FETCH_PERFORMER_SUBSCRIPTION_PLAN_START:
      return {
        ...state,
        subscriptionPlans: {
          data: {
            default: {},
            bundles: [],
          },
          error: false,
          loading: true,
          inputData: {},
        },
      };
    case FETCH_SUBSCRIPTOIN_PLAN_SUCCESS:
      state.freeSubscription.is_free =
        action.data.default.is_free === 1 ? true : false;

      state.onBoardSubscription.is_first_open = (action.data.default.is_free === 1 && action.data.default.amount === 0) ? true : false
      return {
        ...state,
        subscriptionPlans: {
          data: action.data,
          defaultAmount: action.data.default.amount,
          error: false,
          loading: false,
          inputData: {},
        },
      };
    case FETCH_PERFORMER_SUBSCRIPTION_PLAN_SUCCESS:
      return {
        ...state,
        subscriptionPlans: {
          data: action.data,
          error: false,
          loading: false,
          inputData: {},
        },
      };
    case UPDATE_DEFAULT_SUBSCRIPTION:
      return {
        ...state,
        subscriptionPlans: {
          ...state.subscriptionPlans,
          data: {
            ...state.subscriptionPlans.data,
            default: {
              ...state.subscriptionPlans.data.default,
              amount: action.data,
            },
          },
          error: false,
          loading: false,
          inputData: {},
        },
      };
    case IS_SUBSCRIBED_TO_START:
      return {
        ...state,
        isSubscribedTo: {
          data: {},
          error: false,
          loading: true,
        },
      };
    case IS_SUBSCRIBED_TO_SUCCESS:
      return {
        ...state,
        isSubscribedTo: {
          data: action.data,
          error: false,
          loading: false,
        },
      };
    case IS_SUBSCRIBED_TO_FAILURE:
      return {
        ...state,
        isSubscribedTo: {
          data: {},
          error: action.error,
          loading: false,
        },
      };
    case CANCEL_SUBSCRIPTION_START:
      return {
        ...state,
        cancelSubscription: {
          success: false,
          loading: true,
          error: false,
        }
      };
    case CANCEL_SUBSCRIPTION_SUCCESS: {
      return {
        ...state,
        isSubscribedTo: {
          data: {},
          error: false,
          loading: false,
        },
        cancelSubscription: {
          success: true,
          loading: false,
          error: false,
        }
      };
    }
    case CANCEL_SUBSCRIPTION_FAILURE: {
      return {
        ...state,
        isSubscribedTo: {
          ...state.isSubscribedTo,
          error: action.error,
        },
        cancelSubscription: {
          success: false,
          loading: false,
          error: action.error,
        }
      };
    }
    case SUBSCRIBE_TO_PLAN_START: {
      return {
        ...state,
        subscribeToPlan: {
          success: false,
          loading: true,
          error: false,
        }
      }
    }
    case SUBSCRIBE_TO_PLAN_SUCCESS: {
      return {
        ...state,
        subscribeToPlan: {
          success: true,
          loading: false,
          error: false
        }
      }
    }
    case SUBSCRIBE_TO_PLAN_FAILURE: {
      return {
        ...state,
        subscribeToPlan: {
          success: false,
          loading: false,
          error: action.error,
        }
      }
    }
    case SET_SUBSCRIPTION_FREE_START:
      return {
        ...state,
        freeSubscription: {
          ...state.freeSubscription,
          loading: true,
        },
      };
    case SET_SUBSCRIPTION_FREE_SUCCESS:
      return {
        ...state,
        subscriptionPlans: {
          data: action.data,
          error: false,
          loading: false,
          inputData: {},
        },
        freeSubscription: {
          is_free: true,
          loading: false,
        },
      };
    case SET_SUBSCRIPTION_FREE_FAILED:
      return {
        ...state,
        freeSubscription: {
          ...state.freeSubscription,
          loading: false,
        },
      };
    case TOGGLE_SUBSCRIPTION_FREE:
      return {
        ...state,
        freeSubscription: {
          is_free: action.data,
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default SubscriptionPaymentReducer;
